import React, { FC, useState, useMemo, useContext, useEffect, Fragment } from "react";
import GallerySlider from "components/GallerySlider/GallerySlider";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import email from "../../images/email.svg";
import phone from "../../images/phone.svg";
import axios from "axios";
import { API_URL } from "api/config";
import DiscountPopover from "components/DiscountPopover";
import { TagIcon } from "@heroicons/react/24/solid";
import Tooltip from "@mui/material/Tooltip";
import { toast } from "react-toastify";
import { AuthContext } from "context/userContext";
import { Dialog, Transition, Popover } from "@headlessui/react";

export interface StayCardProps {
  key?: any;
  currentProperty?: any;
  data: any;
  size?: any;
  className?: any;
  formikValues?: any;
  discount?:any;
  // setDiscount?:any;
}

const StayCard: FC<StayCardProps> = ({ data, size, className}) => {
  const {
    _id,
    type,
    title,
    price,
    cover_image,
    galleryImgs,
    category,
    viewsCount,
    Address,
    lastMinuteDeal ={},
    deal_id,
    deal_amount,
    city,
  } = data;

  const location = useLocation();
  const isDirecConnectPage = location.pathname === "/account-direktConnects";
  const authContext = useContext(AuthContext);
  const { getOwnerProperty } = authContext;
  const [isVisible, setIsVisible] = useState<boolean>(() => {
    return data?.isHidden === true ? false : true;
  });
  const [showPopover, setShowPopover] = useState(false);
  // const [discount, setDiscount] = useState(lastMinuteDeal.discountValue || "");
  const [updatedPrice, setUpdatedPrice] = useState();
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  const [actionType, setActionType] = useState<"hide" | "unhide" | null>(null);
  const token = localStorage.getItem("token");

  // **Computed Values**
  const cityfirstPart = useMemo(() => {
    if (typeof city === "string" && city.trim()) {
      return city.split(",")[0].trim();
    }
    return "";
  }, [city]);



useEffect(() => {
   if(deal_amount && deal_id){
   setUpdatedPrice(deal_amount);
  }
   }, [deal_id]);
  const setShowDialogFunct = (isVisible: boolean) => {
    const action = isVisible ? "hide" : "unhide";
    setActionType(action);
    setConfirmDialogOpen(true); // open dialog
  };
  // const toggleVisibility = async () => {
  //   const propertyId = _id;
  //   const newVisibilityState = !isVisible;
  //   await setShowDialogFunct(isVisible);
  //   try {
  //     const response = await axios.put(
  //       `${API_URL}/owner/hide/${propertyId}`,
  //       {},
  //       {
  //         headers: {
  //           token: token,
  //         },
  //       }
  //     );
  //     if (response.data.error === false) {
  //       setIsVisible(newVisibilityState);
  //       localStorage.setItem(`isVisible_${_id}`, newVisibilityState.toString());
  //     } else {
  //       toast.error(`${response.data.message}`);
  //     }
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

    // **Slider Gallery**
    const handleConfirmAction = async () => {
  if (!actionType) return;

  const propertyId = _id;
  const newVisibilityState = actionType === "unhide"; // true if unhide, false if hide

  try {
    const response = await axios.put(
      `${API_URL}/owner/hide/${propertyId}`,
      {},
      { headers: { token } }
    );

    if (response.data.error === false) {
      setIsVisible(newVisibilityState);
      localStorage.setItem(`isVisible_${_id}`, newVisibilityState.toString());
      toast.success(`Property ${actionType}d successfully`);
    } else {
      toast.error(response.data.message);
    }
  } catch (error) {
    console.error(error);
    toast.error("Something went wrong");
  } finally {
    setConfirmDialogOpen(false);
    setActionType(null);
  }
};
const toggleVisibility = () => {
  setShowDialogFunct(isVisible);
};

    const renderSliderGallery = () => {
    const combinedArray = [cover_image, ...(galleryImgs || [])]?.filter(img => img && img.trim() !== "");
    return (
      <div className="relative w-full">
        <GallerySlider
          uniqueID={`StayCard_${_id}`}
          ratioClass="aspect-w-4 aspect-h-3 "
          galleryImgs={combinedArray}
          href={`/detail?propID=${_id}`}
          propertyId={_id}
          viewsCount={viewsCount}
          toggleVisibility={toggleVisibility}
          isVisible={isVisible}
          setIsVisible={setIsVisible}
        />
      </div>
    );
  };
  const renderContent = () => {
    return (
      <div className={size === "default" ? "p-4 space-y-4" : "p-3 space-y-2"}>
              {/* Title + Category + Type */}
        <div className="space-y-2">
          <div className="flex items-center space-x-2">
            <h2
              className={` font-medium capitalize ${
                size === "default" ? "lg:text-lg" : "text-base"
              }`}
            >
              <span className="line-clamp-1 text-base">{title}</span>
            </h2>
            { (deal_id && deal_amount) ? (
            <Tooltip title="Active deal" placement="right-start">
              <TagIcon
                className="w-5 h-5 text-orange-500 cursor-pointer"
                onClick={(e) => {
                  e.stopPropagation();
                  e.preventDefault();
                  setShowPopover(!showPopover);
                }}
              />
            </Tooltip>
          ) : 
          ("")
        
          }
          </div>
          <span className="lg:text-xs text-xs text-neutral-500 dark:text-neutral-400 w-full block text-truncate text-nowrap">
            {category}
            <span style={{ margin: "0 5px", fontWeight: "bold" }}>•</span>
            {type}
            <span style={{ margin: "0 5px", fontWeight: "bold" }}>•</span>
            {cityfirstPart}
          </span>
        </div>
        {!isDirecConnectPage ? (
          <div className="flex justify-between items-center">
            <span
              className="text-sm font-medium"
              style={{ fontFamily: "Roboto" }}
            >
             
              {deal_id && deal_amount ? (
              <>
                <span className="text-neutral-500 dark:text-neutral-400 line-through">
                  {Number(price).toLocaleString("en-IN", {
                    style: "currency",
                    currency: "INR",
                    minimumFractionDigits: 0
                  })}
                </span>
                <span className="ml-1 font-semibold">
                  {Number(deal_amount).toLocaleString("en-IN", {
                    style: "currency",
                    currency: "INR",
                    minimumFractionDigits: 0
                  })}
                </span>
              </>
            ) : (
              <span className="font-semibold">
                {Number(price).toLocaleString("en-IN", {
                  style: "currency",
                  currency: "INR",
                  minimumFractionDigits: 0
                })}
              </span>
            )}
            {size === "default" && (
              <span className="text-xs text-neutral-500 dark:text-neutral-400 font-normal">
                /night
              </span>
            )}
            </span>
          {/* Visibility Status */}
            {!isVisible && token && (
              <div className="ml-2 bg-yellow-50 text-yellow-700 text-[11px] px-2  rounded-2xl border-[1.5px] border-yellow-700">
                Hidden from guests
              </div>
            )}
            {isVisible && (
              <button
                className="text-xs bg-custom-color text-white rounded-3xl py-2 px-3"
                onClick={(e) => {
                  e.stopPropagation();
                  e.preventDefault();
                  setShowPopover(!showPopover);
                }}
              >
                {deal_id && deal_amount ? "Edit Deal" : "Set Deal"}
              </button>
            )}
            <DiscountPopover
              showPopover={showPopover}
              setShowPopover={setShowPopover}
              // discount={discount}
              // setDiscount={setDiscount}
              data={data}
              updatedPrice={updatedPrice}
              setUpdatedPrice={setUpdatedPrice}
              expiry={lastMinuteDeal.dealExpires}
              deal_id={deal_id}
              deal_amount={deal_amount}
            />
          </div>
        ) : (
          <div className="details flex justify-between flex-1 items-center">
            <div className="">
              <h2 className=" text-xs  text-neutral-700 font-normal">
                Hosted by
              </h2>
              <div className="flex">
                <p className="text-xs  font-medium">{data.ownerID.firstname}</p>
              </div>
            </div>

            <div className="flex flex-col justify-center items-center">
              <div className="flex justify-center items-center">
                <img src={email} alt="email" className="" />
                <p className=" text-xs  text-neutral-700 ml-1 ">
                  {data?.ownerID?.email || "N/A"}
                </p>
              </div>

              <div className="flex justify-start items-center w-full mt-1">
                <img src={phone} alt="phone" className="" />
                <p className=" text-xs  text-neutral-700 ml-1">
                  {data?.ownerID?.phoneNumber || "NA"}
                </p>
              </div>
            </div>
          </div>
        )}
        <Transition show={confirmDialogOpen} as={Fragment}>
          <Dialog
            as="div"
            className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black bg-opacity-50"
            onClose={() => setConfirmDialogOpen(false)}
          >
            <Dialog.Panel className="bg-white dark:bg-gray-900 p-6 rounded-lg max-w-lg w-full shadow-xl">
              <Dialog.Title className="text-lg font-semibold text-center">
                Confirm Property {(actionType ? actionType.charAt(0).toUpperCase() + actionType.slice(1) : "")}
              </Dialog.Title>
              <p className="text-sm text-gray-600 dark:text-gray-400 text-center mt-2">
                Are you sure you want to {actionType} this property?
              </p>
              <div className="mt-4 flex justify-center gap-4">
                <button
                  onClick={() => setConfirmDialogOpen(false)}
                  className="px-4 py-2 bg-gray-300 dark:bg-gray-700 rounded-md"
                >
                  No, Cancel
                </button>
                <button
                  onClick={handleConfirmAction}
                  className="px-4 py-2 bg-[#022a60] text-white rounded-md"
                >
                  Yes, {(actionType ?? "").charAt(0).toUpperCase() + (actionType ?? "").slice(1)} Property
                </button>
              </div>
            </Dialog.Panel>
          </Dialog>
        </Transition>

      </div>
    );
  };

  return (
    <div
      className={`nc-StayCard group relative bg-white dark:bg-neutral-900 border border-neutral-100 dark:border-neutral-800 rounded-2xl overflow-hidden will-change-transform hover:shadow-xl transition-shadow ${className}`}
      data-nc-id="StayCard"
    >
      {renderSliderGallery()}
      <Link to={`/detail?propID=${_id}`}>{renderContent()}</Link>
    </div>
  );
};

export default StayCard;
